import config from 'lib/config';
import authorizedFetch from 'lib/authorizedFetch';

async function fetchAutolistUser(): Promise<string> {
  return authorizedFetch(`${config.coreApiUrl}/api/current_user`);
}

export default fetchAutolistUser;
